import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CssVarsProvider, CssBaseline } from '@mui/material';
import { Provider } from 'mobx-react';
import theme from '../themes';
import models from '../store';
import AppRoutes from './routes';
import CookieConsent from '../pages/components/cookieConsent';
import { CommonImages } from '../commons/images';

function App() {
    return (
        <CssVarsProvider theme={theme} defaultMode="light">
            <CssBaseline />
            <CookieConsent
                measurementId={import.meta.env.VITE_GA_MEASUREMENT_ID}
                logoSrc={CommonImages.ECAL_LOGO}
            />
            <Provider store={models}>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
            </Provider>
        </CssVarsProvider>
    );
}

export default App;
